import React, { useEffect, useState, useReducer, useContext } from "react";
import { useClaimReg } from "../../../../Hooks/useClaimReg";
import HP_intro from "./HP_intro";
import { useHistory } from "react-router-dom";
import ReEngagedHpPreview from'./ReEngagedHpPreview';
import QuestionnaireCarLoanReEngagedFLP from'./../../../Pages/Splits/QuestionnaireCarLoanReEngagedFLP';

const initialState = {
  intro: false,
  questionnaire: false,
  meritpage: false,
};

const SlideReducer = (state, action) => {
  switch (action.type) {
    case "showSlideChange": {
      const updatedState = Object.keys(state).reduce((acc, key) => {
        acc[key] = key === action.payload ? true : false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
        return acc;
      }, {});
      return { ...state, ...updatedState };
    }
    default:
      return state;
  }
};

const HP_flp = ({
  uuid,
  userDetails,
  pageStatus,
  pendingSlides,
  pendingQuestions,
  followupData
}) => {
  const { clickReEngage } = useClaimReg();
  const source = localStorage.getItem("flp_source");
  const re_engaged_id = localStorage.getItem("re_engagedId");
  const [state, dispatch] = useReducer(SlideReducer, initialState);
  const history = useHistory();

  useEffect(() => {
    slideChange(pendingSlides);
  }, [pendingSlides]);

  const onContinue = async (e) => {
    const claimReg = await clickReEngage(
      uuid,
      re_engaged_id,
      "intro_hp_flp",
      "start_claim",
      e.target.value,
      source
    );
    setTimeout(() => {
      window.scrollTo(0, 0);
      removeFromPending("intro");
    }, 500);
  };

  const removeFromPending = (slidename) => {
    const index = pendingSlides.indexOf(slidename);
    if (index > -1) {
      pendingSlides.splice(index, 1);
    }
    slideChange(pendingSlides);
  };

  const slideChange = (pendingArr) => {
    let pendingCount = pendingArr.length;
    if (pendingCount == 0) {
      history.push("/re_engage_thankyou?uuid=" + uuid);
      return false;
    }
    pendingArr.every((element) => {
      dispatch({ type: "showSlideChange", payload: element });
    });
  };

  return (
    <>
      {state.intro ? (
        <HP_intro onContinue={onContinue} userDetails={userDetails} pageStatus={pageStatus} />
      ) : null}
      {state.questionnaire ? (
        <QuestionnaireCarLoanReEngagedFLP
          pendingQuestions={pendingQuestions}
          pageStatus={pageStatus}
          userDetails={userDetails}
          followupData={followupData}
          removeFromPending={removeFromPending} />
      ) : null}
       {state.meritpage ? (
        <ReEngagedHpPreview userDetails={userDetails} re_engaged_id={re_engaged_id} uuid={uuid} flpSource={source} pageStatus={pageStatus} allFollowupData={followupData} />
      ) : null}

    </>
  )
};

export default HP_flp;
